import { useState } from "react";
import { Next } from "../micro/Next";
import { Tr } from "../micro/Tr";

/**
 * @typedef PiezometriProps
 * @prop {TPiezometro[]} items
 * @prop {(id: string) => void} onItemClick
 * @prop {(id: string) => void} onMouseEnter
 * @prop {(id: string) => void} onMouseOut
 */

/**
 * @typedef TPiezometro
 * @prop {string} id
 * @prop {string} name
 */


/**
 * 
 * @param {PiezometriProps} param0 
 * @returns 
 */
export function Piezometri({
    items,
    onItemClick,
    onMouseEnter,
    onMouseOut,
}) {

    const [hover, setHover] = useState(false)

    const mouseEnter = id => {
        setHover(id)
        onMouseEnter(id)
    }

    const mouseOut = id => {
        setHover(null)
        onMouseOut(id)
    }

    return (
        <>
            <tr className='header-like'>
                <td colSpan={6}><b>Piezometri</b></td>
            </tr>

            {items.map(item =>
                <Tr
                    key={item.id}
                    onClick={() => onItemClick(item.id)}
                    onMouseEnter={() => mouseEnter(item.id)}
                    onMouseOut={() => mouseOut(item.id)}
                    isHover={hover === item.id}
                >
                    <td colSpan={5}>{item.name}</td>
                    <Next><i className="fas fa-chevron-right"></i></Next>
                </Tr>
            )}
        </>
    )
}